import { DateInputV2 } from "@inputs/date/DateInputV2";
import { isValidDate } from "@root/utils/date/isValidDate";
import { useI18nContext } from "@root/utils/organisation";
import { useModalOfferContext } from "../context";

interface IInputProps {
  field: "startDate" | "expirationDate";
  required?: boolean;
}

const fields = {
  startDate: {
    id: "input-start-date",
    label: "Date de début de l'offre",
  },
  expirationDate: {
    id: "input-expiration-date",
    label: "Date d'expiration de l'offre",
  },
};

export const DateInput = ({ field, required }: IInputProps) => {
  const { offer, setOffer, disabled } = useModalOfferContext();
  const { timeZone } = useI18nContext();
  return (
    <DateInputV2
      label={fields[field].label}
      value={offer?.[field] ? new Date(offer[field] as string) : null}
      onChange={(date) => {
        setOffer((offer) => ({
          ...offer,
          [field]: isValidDate(date) ? date : undefined,
        }));
      }}
      disabled={(field === "expirationDate" && !!offer?.isPermanent) || disabled}
      TextFieldProps={{ id: fields[field].id, size: "small", required }}
      timeZone={timeZone}
    />
  );
};
